import { Pagination, Select, Table } from '@shinetools/lumen-react'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

const AVAILABLE_ITEMS_PER_PAGE = [25, 50, 100] as const

export type ItemsPerPage = (typeof AVAILABLE_ITEMS_PER_PAGE)[number]

const itemsPerPageOptions = AVAILABLE_ITEMS_PER_PAGE.map((value) => ({ value: String(value), label: String(value) }))

interface TableFooterProps {
  itemsPerPage: ItemsPerPage
  currentPage: number
  totalPageItems: number
  onPageChange: (page: number) => void
  onItemsPerPageChange: (itemsPerPage: ItemsPerPage) => void
}

export const TableFooter = ({
  itemsPerPage,
  currentPage,
  totalPageItems,
  onPageChange,
  onItemsPerPageChange,
}: TableFooterProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Table.Footer>
      <Table.PageSize label={t('table.items_select.label')}>
        <Select
          options={itemsPerPageOptions}
          value={String(itemsPerPage)}
          onChange={(value) => onItemsPerPageChange(Number(value) as ItemsPerPage)}
          size="small"
        />
      </Table.PageSize>
      <Pagination
        count={Math.max(1, Math.ceil(totalPageItems / itemsPerPage))}
        page={currentPage}
        onPageChange={onPageChange}
        size="small"
      />
    </Table.Footer>
  )
}
